import { axiosInstance } from "..";

export const getBookCategories = async ({ type = "isBook" }) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/categories")
      .then((res) => {
        if (res?.code === 200) {
          let data = res?.data?.categories
            ?.filter((n) => n?.[type])
            .map((item) => {
              return {
                label: item?.name ? item?.name : item?.name,
                isLang: true,
                value: item?._id,
              };
            });
          resolve({
            success: true,
            data: data?.length ? data : [],
            message: res?.message,
          });
        } else {
          reject({ success: false, data: [], message: res?.message });
        }
      })
      .catch((err) => {
        reject({ success: false, data: [], message: err?.message });
      });
  });
};

export const getBookLanguages = async () => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/languages")
      .then((res) => {
        if (res?.code === 200) {
          let data = res?.data?.languages
            ?.filter((n) => n)
            .map((item) => {
              return {
                label: item?.name ? item?.name : "",
                value: item?._id,
                isLang: true,
              };
            });
          resolve({
            success: true,
            data: data?.length ? data : [],
            message: res?.message,
          });
        } else {
          reject({ success: false, data: [], message: res?.message });
        }
      })
      .catch((err) => {
        reject({ success: false, data: [], message: err?.message });
      });
  });
};

export const getBookSeries = async () => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/book-series")
      .then((res) => {
        if (res?.code === 200) {
          let data = res?.data
            ?.filter((n) => n)
            .map((item) => {
              return {
                label: item?.name ? item?.name : "",
                value: item?._id,
              };
            });
          resolve({
            success: true,
            data: data?.length ? data : [],
            message: res?.message,
          });
        } else {
          reject({ success: false, data: [], message: res?.message });
        }
      })
      .catch((err) => {
        reject({ success: false, data: [], message: err?.message });
      });
  });
};

export const getBookAll = async ({ filters, page, limit, type }) => {
  return new Promise((resolve, reject) => {
    var params = {
      pageNo: page,
    };
    if (limit) {
      params.pageSize = limit;
    }
    if (filters?.categories?.length) {
      params.categories = filters?.categories?.join(",");
    }
    if (filters?.languages?.length) {
      params.languages = filters?.languages?.join(",");
    }
    if (filters?.series?.length) {
      params.bookSeries = filters?.series?.join(",");
    }
    if (filters?.search) {
      params.search = filters?.search;
    }
    if (filters?.featured) {
      params.featured = filters?.featured;
    }
    // type filter: "book" for Granth, "literature" for Articles
    if (type) {
      params.type = type;
    }
    axiosInstance
      .get("/books", { params })
      .then((res) => {
        if (res?.code === 200) {
          let data = res?.data?.books
            ?.filter((n) => n)
            .map((item) => {
              return {
                _id: item?._id,
                title: item?.title ? item?.title : "",
                shortDescription: item?.shortDescription
                  ? item?.shortDescription
                  : "",
                image: item?.image ? item?.image : "",
                slug: item?.slug ? item?.slug : "",
                fileUrl: item?.fileUrl ? item?.fileUrl : "",
                fields: [
                  {
                    label: { en: "Author", hi: "लेखक" },
                    value: item?.author?.name ? [item?.author?.name] : [],
                  },
                  {
                    label: { en: "Category", hi: "श्रेणी" },
                    value: item?.categories
                      ?.map((n) => (n?.name ? n?.name : ""))
                      ?.filter((n) => n),
                  },
                  {
                    label: { en: "Language", hi: "भाषा" },
                    value: item?.languageId?.name
                      ? [item?.languageId?.name]
                      : [],
                  },
                  {
                    label: { en: "Part Number", hi: "भाग संख्या" },
                    value: item?.partNo ? item?.partNo : "",
                  },
                ],
              };
            });
          resolve({
            success: true,
            data: {
              list: data,
              total: res?.meta?.total ? res?.meta?.total : 0,
            },
            message: res?.message,
          });
        } else {
          reject({
            success: false,
            data: { list: [], total: 0 },
            message: res?.message,
          });
        }
      })
      .catch((err) => {
        reject({
          success: false,
          data: { list: [], total: 0 },
          message: err?.message,
        });
      });
  });
};
